export default __webpack_public_path__ + "bc13caafe3d6229461d9f5417edfae0d.mov";